import styled from 'styled-components';

export const Blurred = styled.div`
  filter: ${({ blurity }) => (blurity ? `blur(${blurity})` : `blur(1px)`)};
`;
